import { message } from "antd";
import LoginApi from "../../api/Alumno/LoginApi";
import { TOKEN_EGRESADOS } from "../../../../shared/constants";

export default { 
  loginGoogle: async (token) => {
    const response = await LoginApi.loginGoogle(token);
    if (!response.success) {
      message.error(response.message);
    };
    return response;
  },
  loginEgresado: async (data) => {
    const response = await LoginApi.loginEgresado(data);
    if (!response.success) {
      message.error(response.message);
    };
    return response;
  }, 
  checkToken: async (token) => {
      const response = await LoginApi.checkToken(token);
      if (!response.success) {
        message.error(response.message);
        localStorage.removeItem(TOKEN_EGRESADOS);
      };
      return response;
    }, 
};
